const mediaItems = [
  {
    title: '《长安十二时辰 第二季》官方预告',
    type: '预告片',
    views: '386 万次观看',
    duration: '02:35',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20palace%20scene%20with%20warm%20amber%20torchlight%2C%20dramatic%20night%20atmosphere%2C%20historical%20drama%20aesthetic%2C%20rich%20golden%20and%20deep%20red%20tones%2C%20epic%20scale%2C%20film%20grain%20texture%2C%20no%20text%2C%20cinematic%20wide%20shot&width=640&height=360&seq=media-1&orientation=landscape',
  },
  {
    title: '《星际救援：新纪元》幕后特辑',
    type: '花絮',
    views: '215 万次观看',
    duration: '05:18',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20interior%20with%20warm%20golden%20control%20panels%2C%20sci-fi%20film%20set%20atmosphere%2C%20dramatic%20lighting%2C%20deep%20space%20vibe%2C%20rich%20amber%20and%20dark%20tones%2C%20cinematic%20aesthetic%2C%20no%20text%2C%20artistic%20composition&width=640&height=360&seq=media-2&orientation=landscape',
  },
  {
    title: '《人间烟火气》精彩片段合集',
    type: '片段',
    views: '198 万次观看',
    duration: '08:42',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20traditional%20Chinese%20kitchen%20scene%20with%20golden%20steaming%20food%2C%20soft%20natural%20light%20from%20window%2C%20rustic%20wooden%20table%2C%20homely%20atmosphere%2C%20rich%20amber%20tones%2C%20cinematic%20food%20photography%2C%20no%20text%2C%20elegant%20style&width=640&height=360&seq=media-3&orientation=landscape',
  },
  {
    title: '《深渊之下》导演深度专访',
    type: '专访',
    views: '156 万次观看',
    duration: '12:05',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20noir%20style%20interview%20setting%20with%20warm%20key%20light%2C%20deep%20shadows%2C%20elegant%20director%20portrait%20vibe%2C%20cinematic%20lighting%20with%20amber%20tones%2C%20sophisticated%20mood%2C%20rich%20contrast%2C%20no%20text%2C%20artistic%20composition&width=640&height=360&seq=media-4&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            预告片、幕后花絮与独家专访，提前感受精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-accent-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <span className="text-xs font-medium text-accent-500 bg-accent-100/70 px-2 py-0.5 rounded-full mb-2 inline-block">
                  {item.type}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.views}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}